"use strict";

var _classCallCheck = require("/home/abhishek/Documents/Macrometa/demos/tutorial-jamstack-pollingapp/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/abhishek/Documents/Macrometa/demos/tutorial-jamstack-pollingapp/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Search = /*#__PURE__*/function () {
  function Search(connection, searchOptions) {
    _classCallCheck(this, Search);

    this.viewUrlPrefix = "/_api/search/view";
    this.analyzerUrlPrefix = "/_api/search/analyzer";
    this._connection = connection;
    this._viewName = searchOptions && searchOptions.viewName || "";
    this._analyzerName = searchOptions && searchOptions.analyzerName || "";
  }

  _createClass(Search, [{
    key: "setSearch",
    value: function setSearch(collectionName, enable, field) {
      return this._connection.request({
        method: "POST",
        path: "/_api/search/collection/".concat(collectionName),
        qs: {
          enable: enable,
          field: field
        },
        absolutePath: true,
        body: {}
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "searchInCollection",
    value: function searchInCollection(collection, search) {
      var bindVars = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var ttl = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 60;
      return this._connection.request({
        method: "POST",
        path: "/_api/search",
        body: {
          collection: collection,
          search: search,
          bindVars: bindVars,
          ttl: ttl
        },
        absolutePath: true
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "getListOfViews",
    value: function getListOfViews() {
      return this._connection.request({
        method: "GET",
        path: "".concat(this.viewUrlPrefix),
        absolutePath: true
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "createView",
    value: function createView() {
      var properties = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return this._connection.request({
        method: "POST",
        path: "".concat(this.viewUrlPrefix),
        body: {
          type: "search",
          name: this._viewName,
          properties: properties
        },
        absolutePath: true
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "getViewInfo",
    value: function getViewInfo() {
      return this._connection.request({
        method: "GET",
        path: "".concat(this.viewUrlPrefix, "/").concat(this._viewName),
        absolutePath: true
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "renameView",
    value: function renameView(name) {
      return this._connection.request({
        method: "PUT",
        path: "".concat(this.viewUrlPrefix, "/").concat(this._viewName, "/rename"),
        absolutePath: true,
        body: {
          name: name
        }
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "deleteView",
    value: function deleteView() {
      return this._connection.request({
        method: "DELETE",
        path: "".concat(this.viewUrlPrefix, "/").concat(this._viewName),
        absolutePath: true
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "getViewProperties",
    value: function getViewProperties() {
      return this._connection.request({
        method: "GET",
        path: "".concat(this.viewUrlPrefix, "/").concat(this._viewName, "/properties"),
        absolutePath: true
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "updateViewProperties",
    value: function updateViewProperties(properties) {
      return this._connection.request({
        method: "PUT",
        path: "".concat(this.viewUrlPrefix, "/").concat(this._viewName, "/properties"),
        absolutePath: true,
        body: properties
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "getListOfAnalyzers",
    value: function getListOfAnalyzers() {
      return this._connection.request({
        method: "GET",
        path: "".concat(this.analyzerUrlPrefix),
        absolutePath: true
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "createAnalyzer",
    value: function createAnalyzer(type, properties, features) {
      return this._connection.request({
        method: "POST",
        path: "".concat(this.analyzerUrlPrefix),
        body: {
          name: this._analyzerName,
          type: type,
          features: features,
          properties: properties
        },
        absolutePath: true
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "getAnalyzerDefinition",
    value: function getAnalyzerDefinition() {
      return this._connection.request({
        method: "GET",
        path: "".concat(this.analyzerUrlPrefix, "/").concat(this._analyzerName),
        absolutePath: true
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "deleteAnalyzer",
    value: function deleteAnalyzer() {
      var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return this._connection.request({
        method: "DELETE",
        path: "".concat(this.analyzerUrlPrefix, "/").concat(this._analyzerName),
        qs: {
          force: force
        },
        absolutePath: true
      }, function (res) {
        return res.body;
      });
    }
  }]);

  return Search;
}();

exports.Search = Search;